import { API_GetConfig } from 'app/api'
import TagManager from 'react-gtm-module'

export function initializeAnalytics(config?: API_GetConfig) {
  if (config?.service.tagManager.enable === false) return
  if (config?.service.tagManager.key == null){ console.log("TAG Manager Key not defined"); return }

  TagManager.initialize({
    gtmId: config.service.tagManager.key
  })
}